import * as React from 'react';
import { toast as sonnerToast, type ExternalToast } from 'sonner';

type ToastVariant = 'success' | 'info' | 'warning' | 'destructive' | 'loading';

interface ToastProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  variant?: ToastVariant;
}

// oxlint-disable-next-line complexity
function toast({ title, description, variant }: ToastProps) {
  const hasTitle = title !== undefined && title !== null;

  const options: ExternalToast = {
    description: hasTitle ? description : undefined,
  };

  const message = hasTitle ? title : (description ?? '');

  switch (variant) {
    case 'success':
      return sonnerToast.success(message, options);
    case 'destructive':
      return sonnerToast.error(message, options);
    case 'warning':
      return sonnerToast.warning(message, options);
    case 'info':
      return sonnerToast.info(message, options);
    case 'loading':
      return sonnerToast.loading(message, options);
    default:
      return sonnerToast(message, options);
  }
}

function useToast() {
  return { toast };
}

export { useToast, toast };
